import React from "react";

const CAPABILITIES = [
  "Equipment Rental",
  "Casting",
  "Crew",
  "Location Scouting",
  "Film Production",
  "In-House Photographers",
  "Global Locations",
  "Visa Assistance",
  "Styling Assistance",
  "Music Video Production",
  "Makeup Artistry",
  "Vanity Van Rentals",
];

export const Capabilities = () => {
  // Triple the loop for an infinite-feeling marquee
  const loop = [...CAPABILITIES, ...CAPABILITIES, ...CAPABILITIES];

  return (
    <section
      className="relative bg-onyx-800 border-y border-gold/15 py-16 md:py-20 overflow-hidden"
      data-testid="capabilities-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 text-center mb-10">
        <div className="inline-flex items-center gap-3 mb-5">
          <div className="h-px w-10 bg-gold" />
          <span className="font-cinzel text-[11px] tracking-[0.4em] uppercase text-gold">
            Full Capabilities
          </span>
          <div className="h-px w-10 bg-gold" />
        </div>
        <h2 className="font-bebas text-4xl md:text-6xl text-ivory leading-tight" data-testid="capabilities-title">
          Everything Your Production Needs.<br />
          <span className="text-gold-gradient">All Under One Roof.</span>
        </h2>
      </div>

      {/* Marquee strip */}
      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-onyx-800 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-onyx-800 to-transparent" />
        <div className="marquee flex gap-12 whitespace-nowrap py-4">
          {loop.map((c, i) => (
            <div key={`cap-${i}-${c}`} className="inline-flex items-center gap-4 shrink-0">
              <span className="text-gold text-2xl">✦</span>
              <span className="font-bebas text-3xl md:text-5xl text-ivory/70 tracking-wider uppercase">
                {c}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .marquee {
          animation: marquee-scroll 60s linear infinite;
          width: max-content;
        }
        @keyframes marquee-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>
  );
};

export default Capabilities;
